import React from "react";
import L from "leaflet";
import { useMap } from 'react-leaflet/hooks'
import { FeatureGroup } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import Button from '@mui/material/Button';
import BackupIcon from '@mui/icons-material/Backup';
import toGeoJSON from "togeojson";
import JSZip from "jszip";
import './../leaflet.draw.css'

/* DRAW */
/* BUTTONS */
L.drawLocal.draw.toolbar.buttons.polygon = 'Dibuje un polígono';
L.drawLocal.draw.toolbar.buttons.polyline = 'Dibuje una línea';
L.drawLocal.draw.toolbar.buttons.marker = 'Dibuje un punto';
/* ACTIONS */
L.drawLocal.draw.toolbar.actions.title = 'Cancelar dibujo';
L.drawLocal.draw.toolbar.actions.text = 'Cancelar';
/* FINISH */
L.drawLocal.draw.toolbar.finish.title = 'Finalizar dibujo';
L.drawLocal.draw.toolbar.finish.text = 'Finalizar';
/* UNDO */
L.drawLocal.draw.toolbar.undo.title = 'Borrar último punto dibujado';
L.drawLocal.draw.toolbar.undo.text = 'Borrar último punto';
/* HANDLERS */
L.drawLocal.draw.handlers.marker.tooltip.start = 'Click en el mapa para marcar un punto';

L.drawLocal.draw.handlers.polygon.tooltip.start = 'Click para empezar a dibujar una forma';
L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Click para continuar dibujando una forma';
L.drawLocal.draw.handlers.polygon.tooltip.end = 'Click en el primer punto para cerrar la forma';

L.drawLocal.draw.handlers.polyline.error = '<strong>Error:</strong> los bordes de la forma no pueden cruzarse!';
L.drawLocal.draw.handlers.polyline.tooltip.start = 'Click para empezar a dibujar una línea';
L.drawLocal.draw.handlers.polyline.tooltip.cont = 'Click para continuar dibujando una línea';
L.drawLocal.draw.handlers.polyline.tooltip.end = 'Click para continuar dibujando una línea';

/* EDIT */
/* BUTTONS */
L.drawLocal.edit.toolbar.buttons.edit = 'Editar capa';
L.drawLocal.edit.toolbar.buttons.editDisabled = 'No hay capas para editar';
L.drawLocal.edit.toolbar.buttons.remove = 'Borra capas';
L.drawLocal.edit.toolbar.buttons.removeDisabled = 'No hay capas para borrar';
/* ACTIONS */
L.drawLocal.edit.toolbar.actions.save.title = 'Guardar cambios';
L.drawLocal.edit.toolbar.actions.save.text = 'Guardar';

L.drawLocal.edit.toolbar.actions.cancel.title = 'Cancelar edición';
L.drawLocal.edit.toolbar.actions.cancel.text = 'Cancelar';

L.drawLocal.edit.toolbar.actions.clearAll.title = 'Borrar todas las capas';
L.drawLocal.edit.toolbar.actions.clearAll.text = 'Borrar todo';

/* HANDLERS */
L.drawLocal.edit.handlers.edit.tooltip.text = 'Click en el mapa para marcar un punto';
L.drawLocal.edit.handlers.edit.tooltip.subtext = 'Click en cancelar para deshacer los cambios';
L.drawLocal.edit.handlers.remove.tooltip.text = 'Click en un dibujo para borrar';




const DrawTools = (props) => {
	const [displayDiv, setDisplayDiv] = React.useState('grid');
	const map = useMap();
	var kmlGeo = []

	const reverseGeo = (geoJsonArray) => {
		let newGeoJsonArray = []
		geoJsonArray.forEach(geoJson => {
			if (geoJson.geometry.type == "Point") {
				if (geoJson.geometry.coordinates.length == 3) {
					geoJson.geometry.coordinates.pop()
				}
			}
			if (geoJson.geometry.type == "LineString") {
				geoJson.geometry.coordinates = geoJson.geometry.coordinates.map(coord => [coord[0], coord[1]]);
			} else if (geoJson.geometry.type == "Polygon") {
				geoJson.geometry.coordinates = geoJson.geometry.coordinates.map(ring => ring.map(coord => [coord[0], coord[1]]));
			}

			let geometry = JSON.parse(JSON.stringify(geoJson.geometry));
			kmlGeo.push(geometry)

			if (geoJson.geometry.type == "Point") {
				if (geoJson.geometry.coordinates.length == 3) {
					geoJson.geometry.coordinates.pop()
				}
				geoJson.geometry.coordinates = geoJson.geometry.coordinates
			}
			if (geoJson.geometry.type == "LineString") {
				geoJson.geometry.coordinates = geoJson.geometry.coordinates.reverse();
			} else if (geoJson.geometry.type == "Polygon") {
				geoJson.geometry.coordinates = geoJson.geometry.coordinates.map(ring => ring.reverse());
			}
			newGeoJsonArray.push(geoJson.geometry)
		})
		return newGeoJsonArray
	};
	const reverseGeoSave = (geoJson) => {
		if (geoJson && geoJson.type === 'Point') {
			if (geoJson.coordinates.length == 3) {
				geoJson.coordinates.pop()
			}
			geoJson.coordinates = geoJson.coordinates.reverse();
		} else if (geoJson && geoJson.type === 'LineString') {
			geoJson.coordinates = geoJson.coordinates.map(coord => [coord[0], coord[1]].reverse());
		} else if (geoJson && geoJson.type === 'Polygon') {
			geoJson.coordinates = geoJson.coordinates.map(ring => ring.map(coord => [coord[0], coord[1]].reverse()));
		}
		return geoJson
	};
	const getDom = xml => (new DOMParser()).parseFromString(xml, "text/xml")
	const getExtension = fileName => fileName.split(".").pop()
	const getKmlDom = async (kmzFile) => {
		var zip = new JSZip()
		return zip.loadAsync(kmzFile)
			.then(zip => {
				let kmlDom = null
				zip.forEach((relPath, file) => {
					if (getExtension(relPath) === "kml" && kmlDom === null) {
						kmlDom = file.async("string").then(getDom)
					}
				})
				return kmlDom || Promise.reject("No kml file found")
			});
	}
	const addKML = (event) => {

		if (event.target.files != undefined && event.target.files.length != 0) {
			const file = event.target.files[0];
			if (getExtension(file.name) == "kmz") {
				getKmlDom(file).then(kmlDom => {
					const converted = toGeoJSON.kml(kmlDom);
					const convertedGeo = toGeoJSON.kml(kmlDom);
					const geo = reverseGeo(convertedGeo.features)
					props.setGeometry(kmlGeo)
					props.setKml(geo)
				})
			} else {
				file.text().then(kmlText => {
					const parser = new DOMParser();
					const kml = parser.parseFromString(kmlText, "text/xml");
					const converted = toGeoJSON.kml(kml);
					const convertedGeo = toGeoJSON.kml(kml);
					const geo = reverseGeo(convertedGeo.features)
					props.setGeometry(kmlGeo)
					props.setKml(geo)

				})
			}
		}
	};
	const _onEdited = e => {
		let geo = []
		map.eachLayer(layer => {
			if (layer instanceof L.Marker && layer.getLatLng() && layer._icon.className == 'leaflet-marker-icon leaflet-zoom-animated leaflet-interactive' || layer instanceof L.Polygon || layer instanceof L.Polyline) {
				let reverseGeometry = layer.toGeoJSON().geometry /* reverseGeoSave(layer.toGeoJSON().geometry) */
				if (geo.length !== 0) {
					let repeat = []
					geo.forEach(x => {
						if (JSON.stringify(x.coordinates) === JSON.stringify(reverseGeometry)) {
							repeat.push(reverseGeometry)
						}
						if (JSON.stringify(x.coordinates) === JSON.stringify(reverseGeometry)) {
							repeat.push(reverseGeometry)
						}

					})
					if (repeat.length == 0)
						geo.push(reverseGeometry)
				} else {
					geo.push(reverseGeometry)
				}
			}
		});
		props.setGeometry(geo)
	};
	const _onCreated = e => {
		let geo = []

		map.eachLayer(layer => {

			if (layer instanceof L.Marker && layer.getLatLng() && layer._icon.className == 'leaflet-marker-icon leaflet-zoom-animated leaflet-interactive' || (layer instanceof L.Polygon && e.layerType === "polygon") || (layer instanceof L.Polyline && e.layerType === "polyline")) {
				let reverseGeometry = layer.toGeoJSON().geometry /* reverseGeoSave(layer.toGeoJSON().geometry) */
				if (geo.length !== 0) {
					let repeat = []
					geo.forEach(x => {
						if (JSON.stringify(x.coordinates) === JSON.stringify(reverseGeometry.coordinates)) {
							repeat.push(reverseGeometry)
						}
					})
					if (repeat.length == 0)
						geo.push(reverseGeometry)
				} else {
					geo.push(reverseGeometry)
				}
			}
		});

		props.setGeometry(geo)
	};
	const _onDeleted = e => {
		let numDeleted = 0;
		e.layers.eachLayer(layer => {
			numDeleted += 1;
		});
		if (numDeleted != 0) {
			setDisplayDiv('grid')
		};
		let geo = []
		map.eachLayer(layer => {
			if (layer instanceof L.Marker && layer.getLatLng() && layer._icon.className == 'leaflet-marker-icon leaflet-zoom-animated leaflet-interactive' || layer instanceof L.Polygon || layer instanceof L.Polyline) {
				let reverseGeometry = layer.toGeoJSON().geometry /* reverseGeoSave(layer.toGeoJSON().geometry) */
				if (geo.length !== 0) {
					let repeat = []
					geo.forEach(x => {
						if (JSON.stringify(x.coordinates) === JSON.stringify(reverseGeometry)) {
							repeat.push(reverseGeometry)
						}
						if (JSON.stringify(x.coordinates) === JSON.stringify(reverseGeometry)) {
							repeat.push(reverseGeometry)
						}

					})
					if (repeat.length == 0)
						geo.push(reverseGeometry)
				} else {
					geo.push(reverseGeometry)
				}
			}
		});
		props.setGeometry(geo)
	};
	const _onDrawStart = e => {
	};

	return (
		<FeatureGroup>
			<div style={{
				position: 'absolute', zIndex: '1000', cursor: 'pointer', top: '261px', left: '10px', border: '2px solid rgba(0, 0, 0, 0.2)', display: displayDiv,
				borderRadius: '3px'
			}}>
				<input
					accept=".kml,.kmz"
					style={{ display: 'none' }}
					id="contained-button-file"
					type="file"
					onChange={addKML}
				/>
				<label htmlFor="contained-button-file">
					<Button component="span" title="KML" style={{
						borderBottom: '1px solid rgb(204 204 204)', backgroundClip: 'padding-box', backgroundColor: '#f4f4f4', position: 'initial',
						width: '31px', minWidth: '1px', height: '34px', borderRadius: "0px"
					}}>
						<BackupIcon style={{ color: "#464646" }} />
					</Button>
				</label>
				<Button component="span" title="Coordendas" style={{
					backgroundClip: 'padding-box', backgroundColor: '#f4f4f4', position: 'initial',
					width: '31px', minWidth: '1px', height: '34px', borderRadius: "0px"
				}} onClick={() => { props.setOpenCoord(true); props.setKml(null) }}>
					<p style={{ color: "#464646", fontWeight: '900' }}>XY</p>
				</Button>
			</div>
			<EditControl
				onDrawStart={_onDrawStart}
				position="topleft"
				onEdited={_onEdited}
				onCreated={_onCreated}
				onDeleted={_onDeleted}
				draw={{
					polyline: {
						icon: new L.DivIcon({
							iconSize: new L.Point(8, 8),
							className: "leaflet-div-icon leaflet-editing-icon"
						}),
						shapeOptions: {
							guidelineDistance: 10,
							color: "navy",
							weight: 3
						}
					},
					marker: { className: "renderPoint" },
					rectangle: false,
					circlemarker: false,
					circle: false,
					polygon: true
				}} />
		</FeatureGroup>
	);
};

export default DrawTools;
